import { Switch } from '@shared/components/core/field/CommonFieldStyles';
import CommonRow from '@shared/components/core/row/CommonRow';
import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function EmailPreferencesSection() {
    const { t } = useTranslation();

    const currentUser = useCurrentUserStore((state) => state.currentUser);

    const [isEmailOptIn, setIsEmailOptIn] = useState(currentUser?.isEmailOptIn ?? false);

    const handleSaveEmailPreferences = async (v: boolean) => {
        setIsEmailOptIn(v);
        try {
            const result = await useCurrentUserStore.getState().updateEmailPreferences({ isEmailOptIn });
            if (result?.resultType === 'Ok') {
                useAlertsStore.getState().showSuccess(t('common:account.success.marketing'));
            } else {
                useAlertsStore.getState().showError(result?.errors?.join(', ') ?? t('common:account.error.marketing'));
            }
        } catch (error) {
            console.error('Failed to update email preferences:', error);
            useAlertsStore.getState().showError(t('common:account.error.generic'));
        }
    };
    return (
        <>
            <CommonRow thin title={t('common:account.marketing.optIn')} titleId={`emailPreferences-label`}>
                <Switch
                    aria-labelledby={`emailPreferences-label`}
                    checked={isEmailOptIn}
                    onChange={() => {
                        handleSaveEmailPreferences(!isEmailOptIn);
                    }}
                />
            </CommonRow>
        </>
    );
}
